import { SignInInputState } from "service/shared/others/SignInInputService/SignInInput.state";
import { KeyboardCustomEvent } from "types/libExtend/KeyboardCustomEvent";
import { passwordValidateFunction } from "utils/business/passwordValidateFunction/passwordValidateFunction";
import { onChangeHelper } from "utils/commonExtend/onChangeHelper";

export class SignInInputController {
  public readonly state: SignInInputState;

  public readonly onChange = onChangeHelper((text: string): void => {
    const errorObject = passwordValidateFunction(text);

    this.state.digitsState.next(errorObject.hasDigitsError);
    this.state.lengthState.next(errorObject.hasLengthError);
    this.state.lowercaseLettersState.next(errorObject.hasLowercaseLettersError);
    this.state.russianLetterState.next(errorObject.hasRussianLetterError);
    this.state.specialSymbolsState.next(errorObject.hasSpecialSymbolsError);
    this.state.uppercaseLettersState.next(errorObject.hasUppercaseLettersError);
    this.state.value.next(text);
    this.state.valid.next(this.state.validate(text));
  });

  public constructor(state: SignInInputState) {
    this.state = state;
  }

  public readonly clearForm = (): void => {
    this.state.value.next("");
  };

  public readonly onKeyUp = (event: KeyboardCustomEvent): void => {
    const capsLockState = event.getModifierState("CapsLock");
    this.state.capsLockState.next(capsLockState);
  };

  public readonly setShowError = (showError: boolean): void => {
    this.state.showError.next(showError);
  };
}
